<script>
  import ItemPreviewList from "$lib/components/ItemPreviewList.svelte";
  import {
    getPaginatedItemPreviewListItems,
    getThemedItemIds
  } from "$lib/utilities/contentTypes/itemPreviewList";

  /** @type { string } */
  let className = "";
  export { className as class };

  export let data;
  export let itemsPerPage = 36;

  // Tag automation gets the preference
  const isPopulatedByPathOrTag = !!data.fields?.itemsSource || !!data.fields?.pathQuery;
  const itemsData = isPopulatedByPathOrTag ? data.children : data.fields?.listItems;
  const itemsFormFactor = data.fields.itemsFormFactor;

  const themedItemIds = getThemedItemIds(data.fields?.themedItems);
  const featuredItems = data.fields?.featuredItems ?? [];
  const excludedItems = data.fields?.excludedItems ?? [];
  const sourceTagItemId = data.fields?.itemsSource ? data.fields?.itemsSource.sys?.id : null;
  const paginatedItems =
    getPaginatedItemPreviewListItems({
      itemsData,
      itemsFormFactor,
      themedItemIds,
      featuredItems,
      excludedItems,
      sourceTagItemId,
      itemsPerPage,
      isPopulatedByPathOrTag
    }) ?? [];
</script>

<ItemPreviewList class={className} {itemsFormFactor} items={paginatedItems} iplId={data.sys?.id} />
